module.exports = __webpack_public_path__ + "media/glycolic-small.7749393d.mp4";